module.exports = __webpack_public_path__ + "fonts/Lexend-500-latin15.54a1d08.woff2";